import React from 'react'
import { IconSVGType } from '../../types/icons'

const PlastiqPriorityIcon = (props: IconSVGType) => {
  return (
    <svg
      width='62'
      height='19'
      viewBox='0 0 62 19'
      style={{
        width: '3.125rem',
        position: 'relative',
        top: '0.313rem',
        marginLeft: '0.125rem',
      }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.2777 0.640137H19.7264C19.4419 0.640137 19.2285 0.83575 19.2285 1.13806V14.1018C19.2285 14.4041 19.4241 14.5998 19.7264 14.5998H20.2777C20.5622 14.5998 20.7756 14.4041 20.7756 14.1018V1.12028C20.7578 0.83575 20.5622 0.640137 20.2777 0.640137Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M31.3922 5.08575H30.8588C30.592 5.08575 30.3964 5.26358 30.3608 5.56589L30.3253 6.24164C29.525 5.37028 28.4047 4.89014 27.1777 4.89014C24.5102 4.89014 22.5186 7.02409 22.5186 9.85158C22.5186 11.1675 22.9809 12.3768 23.8167 13.2837C24.6881 14.2084 25.8795 14.7241 27.1777 14.7241C28.4047 14.7241 29.5073 14.2618 30.3253 13.4082L30.3608 14.1195C30.3964 14.404 30.592 14.5996 30.8588 14.5996H31.3922C31.6768 14.5996 31.8902 14.404 31.8902 14.1017V5.58367C31.8902 5.28136 31.6768 5.08575 31.3922 5.08575ZM27.2488 13.2837C25.3994 13.2837 24.0123 11.7899 24.0123 9.8338C24.0123 8.85573 24.3502 7.96659 24.937 7.3264C25.5239 6.68622 26.3597 6.33056 27.2488 6.33056C29.0449 6.33056 30.4497 7.87767 30.4497 9.8338C30.4497 11.7721 29.0449 13.2837 27.2488 13.2837Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M37.3675 9.08712C36.3005 8.71367 35.2869 8.34023 35.2869 7.50444C35.2869 6.95316 35.6959 6.29519 36.834 6.29519C37.7231 6.29519 38.2922 6.66864 38.9324 7.25547C39.0924 7.41552 39.2525 7.45108 39.3414 7.4333C39.4125 7.41552 39.5548 7.39774 39.6615 7.25547L39.8927 6.98873C40.1238 6.66864 39.9994 6.43746 39.9104 6.33076C39.0569 5.33491 37.7943 4.87256 36.9051 4.87256C35.1446 4.87256 33.8287 5.99288 33.8287 7.50444C33.8287 9.26495 35.3224 9.79843 36.7629 10.3319C37.8832 10.7409 38.9502 11.1144 38.9502 12.0924C38.9502 12.8571 38.2566 13.355 37.1897 13.355C35.8737 13.355 34.9134 12.4125 34.7178 12.2169C34.6111 12.1102 34.4866 12.0035 34.3266 12.0035C34.2199 12.0213 34.1132 12.0747 34.0243 12.1814L33.6864 12.5548C33.6153 12.6437 33.473 12.8927 33.722 13.195C34.0421 13.5684 35.2335 14.7777 37.2074 14.7777C38.7723 14.7777 40.4795 13.7462 40.4795 12.0747C40.4261 10.1897 38.7901 9.60282 37.3675 9.08712Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M46.454 5.08608H44.5156V1.12048C44.5156 0.818172 44.32 0.622559 44.0177 0.622559H43.4664C43.1819 0.622559 42.9685 0.818172 42.9685 1.12048V5.08608H41.7059C41.4214 5.08608 41.208 5.28169 41.208 5.584V5.99301C41.208 6.29532 41.4036 6.49093 41.7059 6.49093H42.9685V14.102C42.9685 14.4043 43.1641 14.6 43.4664 14.6H44.0177C44.3022 14.6 44.5156 14.4043 44.5156 14.102V6.47315H46.4362C46.7207 6.47315 46.9341 6.27754 46.9341 5.97523V5.584C46.9341 5.28169 46.7385 5.08608 46.454 5.08608Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M49.1033 0.622559C48.5342 0.622559 48.1074 1.03157 48.1074 1.60062C48.1074 2.16968 48.5164 2.59647 49.1033 2.59647C49.6545 2.59647 50.0635 2.16968 50.0635 1.60062C50.0458 1.04935 49.6368 0.622559 49.1033 0.622559Z'
        fill='black'
        fillOpacity='0.6'
      />
      <path
        d='M49.3529 5.08594H48.8016C48.5171 5.08594 48.3037 5.28155 48.3037 5.58386V14.1019C48.3037 14.4042 48.4993 14.5998 48.8016 14.5998H49.3529C49.6374 14.5998 49.8508 14.4042 49.8508 14.1019V5.58386C49.8508 5.28155 49.6552 5.08594 49.3529 5.08594Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M60.8583 12.6793C61.4629 11.8435 61.8363 10.7943 61.8363 9.65616C61.8363 6.82867 59.5601 4.53467 56.7326 4.53467C53.9229 4.53467 51.6289 6.82867 51.6289 9.65616C51.6289 12.4836 53.9051 14.7776 56.7326 14.7776C57.8707 14.7776 58.9199 14.4042 59.7557 13.7818L60.5204 14.5465C60.716 14.7421 61.0361 14.7421 61.2317 14.5465L61.6051 14.173C61.8008 13.9774 61.8008 13.6573 61.6051 13.4617L60.8583 12.6793ZM56.7504 13.1416C54.8298 13.1416 53.2827 11.5945 53.2827 9.67394C53.2827 7.75338 54.8298 6.20627 56.7504 6.20627C58.671 6.20627 60.2181 7.75338 60.2181 9.67394C60.2181 10.3497 60.0225 10.9899 59.6846 11.5056L58.8488 10.6698C58.6532 10.4742 58.3331 10.4742 58.1375 10.6698L57.764 11.0432C57.5684 11.2388 57.5684 11.5589 57.764 11.7545L58.5998 12.5903C58.0663 12.946 57.4261 13.1416 56.7504 13.1416Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M2.88583 6.63298L0.165039 5.05029V17.4094L2.9214 18.9921V6.63298C2.90361 6.63298 2.88583 6.63298 2.88583 6.63298Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M16.4009 4.60578L8.41639 0L0.414062 4.60578L3.13485 6.18847L3.15264 6.20625L8.39861 3.18315L13.6624 6.22403L16.4009 4.60578Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M11.2254 7.93111L8.43348 6.33064L5.65935 7.93111L8.43348 9.53157L11.2254 7.93111Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        opacity='0.99'
        d='M5.62402 8.29248V11.3205L8.30098 12.7746V9.81397L5.62402 8.29248Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M8.66602 9.84802V12.8373L11.2781 11.3344V8.36182L8.66602 9.84802Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M13.911 6.66854V12.697L8.66504 15.7201V18.8854L16.6496 14.2796V5.05029L13.911 6.66854Z'
        fill='black'
        fillOpacity='0.7'
      />
      <path
        d='M8.14977 15.7202L5.66016 14.2798V17.4452L8.14977 18.8856V15.7202Z'
        fill='black'
        fillOpacity='0.7'
      />
    </svg>
  )
}

export default PlastiqPriorityIcon
